module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block"
  }, [_c('Icon', {
    attrs: {
      "size": "big",
      "type": _vm.item.type
    }
  }), _c('div', {
    staticClass: "block__info"
  }, [(_vm.item.title) ? _c('h3', {
    staticClass: "block__title"
  }, [_vm._v(_vm._s(_vm.item.title))]) : _vm._e(), (_vm.showAddition) ? [(!_vm.isShow) ? _c('p', {
    staticClass: "block__hidden_info",
    on: {
      "click": _vm.openMoreInfo
    }
  }, [_vm._v("Подробнее")]) : _vm._e(), (_vm.isShow) ? _c('p', {
    staticClass: "block__hidden_info",
    on: {
      "click": _vm.closeMoreInfo
    }
  }, [_vm._v("Скрыть")]) : _vm._e()] : _vm._e(), _c('div', {
    staticClass: "block__description_show"
  }, [(_vm.item.group_name) ? _c('p', {
    staticClass: "block__description_no_margin"
  }, [_c('b', [_vm._v("Группа:")]), _vm._v(" " + _vm._s(_vm.item.group_name))]) : _vm._e(), (_vm.item.events_name && _vm.isShow) ? _c('p', {
    staticClass: "block__description_no_margin"
  }, [_c('b', [_vm._v("Программа:")]), _vm._v(" " + _vm._s(_vm.item.events_name))]) : _vm._e(), (_vm.item.module_name && _vm.isShow) ? _c('p', {
    staticClass: "block__description_no_margin"
  }, [_c('b', [_vm._v("Модуль:")]), _vm._v(" " + _vm._s(_vm.item.module_name))]) : _vm._e(), (_vm.item.theme_name && _vm.isShow) ? _c('p', {
    staticClass: "block__description_no_margin"
  }, [_c('b', [_vm._v("Тема:")]), _vm._v(" " + _vm._s(_vm.item.theme_name))]) : _vm._e(), (_vm.item.lesson_name && _vm.isShow) ? _c('p', {
    staticClass: "block__description_no_margin"
  }, [_c('b', [_vm._v("Урок:")]), _vm._v(" " + _vm._s(_vm.item.lesson_name))]) : _vm._e()]), (_vm.item.announce) ? _c('p', {
    staticClass: "block__description"
  }, [_vm._v(_vm._s(_vm.item.announce))]) : (_vm.item.description) ? _c('p', {
    staticClass: "block__description",
    domProps: {
      "innerHTML": _vm._s(_vm.item.description)
    }
  }) : _vm._e(), _c('Legend', {
    attrs: {
      "isDateAfterToday": _vm.isDateAfterToday,
      "date": _vm.date,
      "type": _vm.item.type,
      "student_url": _vm.item.student_url,
      "record_url": _vm.item.record_url,
      "webinar_started": _vm.item.webinar_started,
      "link_state": _vm.item.link_state,
      "files": _vm.files,
      "isOpenBlock": _vm.isOpenBlock,
      "isResult": _vm.isResult
    },
    on: {
      "close": _vm.closeItemBlock,
      "lookItems": _vm.openItemsBlock
    }
  }), (_vm.isOpenBlock) ? _c('ItemsBlock', {
    attrs: {
      "links": _vm.links,
      "files": _vm.files,
      "description": _vm.item.description
    }
  }, [(_vm.isResult) ? _c('Result', {
    attrs: {
      "slot": "result",
      "result": _vm.item.result,
      "isChecked": _vm.isChecked
    },
    slot: "result"
  }) : _vm._e(), (_vm.isTest) ? _c('ResultForm', {
    attrs: {
      "slot": "form",
      "kidId": _vm.id,
      "testId": _vm.item.id,
      "schedule-id": _vm.item.schedule_id
    },
    slot: "form"
  }) : _vm._e()], 1) : _vm._e(), (_vm.isExamination && _vm.item.result_params && _vm.item.result_params.passed) ? _c('ExaminationResult', {
    attrs: {
      "result": _vm.item
    }
  }) : _vm._e(), (_vm.isExamination) ? _c('AppRouterLink', {
    staticClass: "block__link",
    attrs: {
      "mod": "small",
      "to": _vm.getRouterData
    }
  }, [_vm._v("Перейти к выполнению теста")]) : _vm._e()], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22916b52","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/components/info/compopnents/block/Block.vue
// module id = 734d4387d088fc988c55
// module chunks = 89